import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as golfActions from './../../../../actions/golfAction';
import Golf from './Golf';

const mapStateToProps = state => {
    return {
        golfState: state.golfReducer,
        rateState: state.rateReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListGolf: (filters) => dispatch(golfActions.getListGolf(filters)),
        syncAllGolf: () => dispatch(golfActions.syncAllGolf()),
        updateGolfOrder: (data) => dispatch(golfActions.updateGolfOrder(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Golf));
